import { FormCard, FormItem, Input } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

const PlanNameFormCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
    <FormCard title={t(supConstants.PLAN_NAME)}>
      <FormItem
        name="planName"
        rules={[
          {
            required: true,
            message: `${t(supConstants.PLEASE_ENTER)} ${t(
              supConstants.PLAN_NAME
            )}`
          }
        ]}
      >
        <Input maxLength={50} />
      </FormItem>
    </FormCard>
  )
}

export default PlanNameFormCard
